import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const CovidTestingSolutions = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 py-md-5 py-4' style={{ }}>
            <Row className=''>
                <Col md='12' lg='7' className=''>
                    <div className='pe-md-4'>
                        <div className=''>
                            <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh- pb-2'>
                                COVID-19 TESTING SOLUTIONS
                            </div>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className=''>
                            <div className='fs-ss-20 text-montserrat fw-600 text-ss-black' style={{ fontStyle:'italic', letterSpacing:'0.5px'}}>
                                Covid & PCR Testing solutions in Chicago For Individuals and Organizations
                            </div>
                        </div>

                        <div className='py-3 pe-md-5'>
                            <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                            United Lab Care is on a mission to deliver and enhance healthcare for everyone. We provide reliable and effective COVID test in Chicago which include RT-PCR and Rapid Antigen tests conducted at our testing locations or weekly at your business or organization.
                            We help communities, organizations, and educational institutions safely return to study or work. If you are traveling or have a medical need to get tested, we are there for you because United Lab Care provides you with rapid Covid testing in Chicago.                            
                            </div>
                        </div>

                        <div className='pt-2'>
                        <Link to='/book-covid-test-appointment'>
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                                    SCHEDULE YOUR COVID TEST
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>
                <Col md='12' lg='' className='pt-md-5 pt-5'>
                    <div className='flex-center'>
                        <img src='covid-testing/Covid-Testing-img1-v1.png' alt='' className='img-w5-2' width='%' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default CovidTestingSolutions